import React, { useEffect, useMemo } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import {  LivexHistoricDataPoint } from "../../../../context/vinousCellarsContext/reducer";
import { useVinousCellarsContext, getLivexPriceHistory } from "../../../../context/vinousCellarsContext";
import Loading from "../../Loading";

const WinePriceHistory = (props: {
  wineName: string,
  lwin11: string
}) => {

  const { wineName, lwin11 } = props;

  const { state: vinousCellarsState, dispatch: vinousCellarsDispatch } = useVinousCellarsContext();

  useEffect(() => {
    if (lwin11 && !vinousCellarsState.livexHistoricData[lwin11]) {
      getLivexPriceHistory(vinousCellarsDispatch, lwin11, "USD");
    }
  }, [lwin11])


  const livexHistoricData = vinousCellarsState.livexHistoricData[lwin11];

  const chartDataFmt = useMemo(() => {
    return livexHistoricData && {
      name: wineName,
      data: livexHistoricData
        .sort((a, b) => a.date_string.localeCompare(b.date_string))
        .map(({ date_string, value }) => {
          return [Date.parse(date_string), parseInt(value)];
        }),
      tooltip: {
        pointFormatter: function(): string {
          let s = `$${this.y.toLocaleString(undefined, { maximumFractionDigits: 2 })} Value over Time (/12x75cl Cs)<br/>`;
          return s;
        },
      },
    };
  }, [livexHistoricData, wineName]);

  if (!vinousCellarsState.loading && chartDataFmt?.data?.length > 0) {
    return (
      <>
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            series: [chartDataFmt],
          }}
          constructorType="stockChart"
        />
      </>
    );
  } else if (chartDataFmt?.data?.length <= 0) {
    return <p className="my-2 font-light">Price history data unavailable.</p>;
  } else {
    return <Loading isLoading />;
  };
};

export default WinePriceHistory;
